<div class="{{ css }}">
  <button
    [disabled]="!isShowDevicesPermission || !isDevicePermissionAvailable"
    tabindex="0"
    class="btn btn-{{ buttonStyle }}"
    (click)="navigateTo()"
    id="btn-default"
  >
    {{ text }}
  </button>
</div>
